export var HIDE_FLAG = 'conversional-hideExitIntent';
export var DELAY_TO_ACTIVATE = 5000;
